export enum ApplicationActionTypes {
	FETCH_DATA = '@@application/FETCH_DATA',
	FETCH_DATA_SUCCEED = '@@application/FETCH_DATA_SUCCEED',
	FETCH_DATA_FAILED = '@@application/FETCH_DATA_FAILED',
}
